import {
  IncludeOptions,
  TodistusPyyntö,
} from 'todistukset-common/src/vtj/types/todistus'
import { finalEditableFieldValue } from 'todistukset-common/src/vtj/types/editable-field.type'

export const getIncludeOptionsFromTodistusPyynto = (
  todistusPyynto: Pick<TodistusPyyntö, keyof IncludeOptions>
): IncludeOptions => ({
  includeHetu: !!finalEditableFieldValue(todistusPyynto.includeHetu),
  includeMaritalStatus: !!finalEditableFieldValue(
    todistusPyynto.includeMaritalStatus
  ),
  includePreviousPermanentAddresses: !!finalEditableFieldValue(
    todistusPyynto.includePreviousPermanentAddresses
  ),
  previousAddressesOverYears:
    finalEditableFieldValue(todistusPyynto.previousAddressesOverYears) ?? 0,
  includePreviousMarriages: !!finalEditableFieldValue(
    todistusPyynto.includePreviousMarriages
  ),
  includePreviousNames: !!finalEditableFieldValue(
    todistusPyynto.includePreviousNames
  ),
  includeSpousePreviousNames: !!finalEditableFieldValue(
    todistusPyynto.includeSpousePreviousNames
  ),
  includeNationality: !!finalEditableFieldValue(
    todistusPyynto.includeNationality
  ),
  includePermanentAddress: !!finalEditableFieldValue(
    todistusPyynto.includePermanentAddress
  ),
  includePreviousTemporaryAddresses: !!finalEditableFieldValue(
    todistusPyynto.includePreviousTemporaryAddresses
  ),
  includePreviousKotikunta: !!finalEditableFieldValue(
    todistusPyynto.includePreviousKotikunta
  ),
  includeKotikunta: !!finalEditableFieldValue(todistusPyynto.includeKotikunta),
  includeParentsHetu: !!finalEditableFieldValue(
    todistusPyynto.includeParentsHetu
  ),
  includeParentsPreviousNames: !!finalEditableFieldValue(
    todistusPyynto.includeParentsPreviousNames
  ),
  includeNumberOfMarriages: !!finalEditableFieldValue(
    todistusPyynto.includeNumberOfMarriages
  ),
})
